import * as Yup from "yup";

import { yupObjectValidation } from "../../../validationServices";

export const useOrganizationJoinValidationSchema = () => {
  const initialValues = {
    companyName: "",
  };

  const validationSchema = {
    companyName: yupObjectValidation.company_name4,
  };

  const organizationJoinValidationSchema = Yup.object().shape(validationSchema);

  return {
    initialValues,
    organizationJoinValidationSchema,
  };
};
